import { OwcCard, OwcTooltip, OwcTypography } from "@one/react";
import { getFile } from "./log-sheet/log-sheet-form/downloadFile";
import { generateID } from "@digitallab/grid-common-frontend-components";
import {
  LinkContainerDivInnerLeft,
  LinkContainerDivInnerRight,
  LinkContainerDivView,
  LinkContainerStyled
} from "./log-book-item-form-dialog/FormsStyled";
import FileIcon from "../../icons/FileIcon";
import DownloadIcon from "../../icons/DownloadIcon";
import { compose } from "redux";
import { connect } from "react-redux";
import { withApollo } from "react-apollo";
import { LOGBOOK_ATTACHMENTS } from "../../constants";

const FILE_NAME_LIMIT = 35;
const shortenFileName = (fileName, limit) => {
  if (fileName.length <= limit) {
    return fileName;
  }

  const beginning = fileName.substring(0, limit / 2);
  const ending = fileName.slice(- limit / 2);
  return `${beginning}...${ending}`;
}

const ActionLogFileList = ({ attachments }) => {
  const filteredAttachments = attachments?.filter(
    (i) => i.status === LOGBOOK_ATTACHMENTS.STATUS.ACTIVE
  );
  return filteredAttachments?.length ?
    (
      <div style={{margin: "10px 0"}}>
        <OwcCard
          flat
          style={{
            padding: "0px",
            width: "90%",
            border: "1px solid var(--one-color-interaction-default-neutral-2)"
          }}
        >
          <div
            slot="header"
            style={{
              display: "flex",
              background: "var(--one-color-background-neutral-2)",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "-3px",
              padding: "10px"
            }}
          >
            <OwcTypography
              variant="button"
              id={generateID.UUID("AddLinkHeadingBanner", `addLinkHeadingBanner`, "type_title")}
            >
              <strong>File list</strong>
            </OwcTypography>
          </div>
          <LinkContainerStyled
            data-testid="link-block"
            id={generateID.UUID("LinkBlock", `link_block`, "div")}
          >
            {filteredAttachments.map((item, index) => {
                return (
                  <LinkContainerDivView key={`file${index}`}>
                    <LinkContainerDivInnerLeft>
                      <FileIcon style={{minWidth: '16px'}} />
                      <div style={{width: "100%"}}>
                        <OwcTypography
                          id={`file-description-${index}`}
                          variant="subtitle2"
                          style={{
                            marginLeft: "5px",
                            marginRight: "10px",
                            color: "var(--one-color-interaction-default-brand-1)",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            textOverflow: "ellipsis"
                          }}
                        >
                          {item.fileDescription}
                          <OwcTooltip anchor={`file-description-${index}`} placement="top">
                            {item.fileDescription}
                          </OwcTooltip>
                        </OwcTypography>
                      </div>
                    </LinkContainerDivInnerLeft>
                    <LinkContainerDivInnerRight>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        cursor: "pointer",
                        marginRight: "5px"
                      }}>
                        <OwcTypography
                          id={`file-name-${index}`}
                          variant="subtitle2"
                          style={{
                            marginRight: "5px",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            textOverflow: "ellipsis"
                          }}
                        >
                          {shortenFileName(item.fileName, FILE_NAME_LIMIT)}
                          <OwcTooltip anchor={`file-name-${index}`} placement="top">
                            {item.fileName}
                          </OwcTooltip>
                        </OwcTypography>
                        <span
                          onClick={() => getFile(item)}
                          style={{
                            color: "var(--one-color-interaction-default-brand-1)"
                          }}
                        >
                          <DownloadIcon />
                        </span>
                        <OwcTooltip anchor={generateID.UUID("LinkBlockEdit", `link_block`, `icon-${index}`)}>
                          {"Link"}
                        </OwcTooltip>
                      </div>
                    </LinkContainerDivInnerRight>
                  </LinkContainerDivView>
                );
              })}
          </LinkContainerStyled>
        </OwcCard>
      </div>
    ) :
    (
      <></>
    );
}

const mapStateToProps = (store) => ({
  user: store.user
});

export default compose(connect(mapStateToProps, {}), withApollo)(ActionLogFileList);
